import React, {PureComponent} from "react";
import './style.css';
import {Button} from "reactstrap";

export class UpdownComponent extends PureComponent {

    render() {
        return <div className={'component-updown ' + this.props.className}>
            <Button
                disabled={this.props.upDisabled}
                onClick={(e)=>{
                    this.props.onClick && this.props.onClick(true);
                    e.stopPropagation();
                }}
                className={'button-updown up'} size={'sm'} color="secondary">▲</Button>
            <Button
                disabled={this.props.downDisabled}
                onClick={(e)=>{
                    this.props.onClick && this.props.onClick(false);
                    e.stopPropagation();
                }}
                className={'button-updown'} size={'sm'} color="secondary">▼</Button>
        </div>;
    }

}


// WEBPACK FOOTER //
// ./src/03-components/Updown/updown.js